import React from 'react';

import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

const PAGE_WIDTH = Settings.device.isMobile ? 11 : 14;

const PDFPages = ({ viewer }) =>
    <span className='ctrl-tool page-control'>
        <span
            className='icon icon-page-up'
            onClick={viewer.prevPage}
            title={gettext('Previos page')}
            ga-action='File_View_Controller'
            ga-label='Click_Previous_Page'
            data-what='controller-tool'
            data-which='prev-page'
        />
        <input
            className='controller-input'
            ref={input => { viewer.input = input; }}
            defaultValue={viewer.currentPage}
            onChange={viewer.onInputChange}
            onBlur={viewer.changePage}
            onFocus={viewer.props.store.ui.controller.show}
            ga-action='File_View_Controller'
            ga-label='Click_Page_Input'
            style={{ maxWidth: `${viewer.numberOfPages ? viewer.currentPage.toString().split('').length * PAGE_WIDTH : PAGE_WIDTH}px` }}
        />
        <span>/</span>
        <span className='num-pages'>{viewer.numberOfPages}</span>
        <span
            className='icon icon-page-down'
            onClick={viewer.nextPage}
            title={gettext('Next page')}
            ga-action='File_View_Controller'
            ga-label='Click_Next_Page'
            data-what='controller-tool'
            data-which='next-page'
        />
    </span>;

PDFPages.propTypes = {
    viewer: PropTypes.object
};

export default observer(PDFPages);
